import React, {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';

const CRISP_WEBSITE_ID = process.env.REACT_APP_CRISP_WEBSITE_ID;

interface CrispChatProps {
  user: {
    email?: string;
    nickname?: string;
    avatar?: string;
  } | null;
}

const CrispChat: React.FC<CrispChatProps> = ({user}) => {
  const [isChatLoaded, setIsChatLoaded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (user) {
      (window as any).$crisp = (window as any).$crisp || [];
      (window as any).CRISP_WEBSITE_ID = CRISP_WEBSITE_ID;

      // Globale Funktion zum Öffnen des Chats
      (window as any).openCrispChat = () => {
        if ((window as any).$crisp) {
          // Zuerst show, dann open um sicherzugehen dass es sichtbar wird
          (window as any).$crisp.push(['do', 'chat:show']);
          (window as any).$crisp.push(['do', 'chat:open']);
        }
      };

      // Initial verstecken mit do-Befehl (stabiler als set-Namespace)
      (window as any).$crisp.push(['do', 'chat:hide']);

      const handleLoad = () => {
        setTimeout(() => setIsChatLoaded(true), 100);
      };

      (window as any).$crisp.push(['on', 'session:loaded', handleLoad]);

      // Event Listeners mit logs
      (window as any).$crisp.push(['on', 'chat:opened', () => {
      }]);

      (window as any).$crisp.push(['on', 'chat:closed', () => {
        setTimeout(() => {
          if ((window as any).$crisp) {
            (window as any).$crisp.push(['do', 'chat:hide']);
          }
        }, 50);
      }]);

      if (!document.getElementById('crisp-script')) {
        const script = document.createElement('script');
        script.id = 'crisp-script';
        script.src = 'https://client.crisp.chat/l.js';
        script.async = true;
        document.head.appendChild(script);
      }

      (window as any).$crisp.push(['set', 'user:email', [user.email]]);
      (window as any).$crisp.push(['set', 'user:nickname', [user.nickname]]);

      if (user.avatar) {
        (window as any).$crisp.push(['set', 'user:avatar', [user.avatar]]);
      }

      return () => {
        delete (window as any).openCrispChat;
      };
    }
  }, [user]);

  // Bei Route-Wechsel: Sicherstellen dass der Chat versteckt bleibt
  useEffect(() => {
    if ((window as any).$crisp && isChatLoaded) {
      (window as any).$crisp.push(['do', 'chat:hide']);
    }
  }, [location, isChatLoaded]);

  if (!user || !isChatLoaded) return null;

  return (
      <style>{`
        /* Kill all launcher button variations via CSS to prevent them from showing up */
        .crisp-client .cc-kv6e,
        .crisp-client .cc-1663,
        .crisp-client .cc-un7o,
        .crisp-client .cc-1m8v,
        .crisp-client [data-is-floating="true"] {
          display: none !important;
          visibility: hidden !important;
          opacity: 0 !important;
          pointer-events: none !important;
        }

        /* Ensure the chatbox itself remains functional when opened via API */
        #crisp-chatbox {
          visibility: visible !important;
        }
      `}</style>
  );
};

export default CrispChat;